export const nuevo = [
    {
        "anio" : "Asistencia a Proyectos Turísticos",
        "descripcion" : "Orientar y determinar los alcances de un Proyecto Turístico para su viabilidad",
        "trimestres" : [
            {
                "trimestre" : "",
                "url" : "http://ruts.hidalgo.gob.mx/ver/1182"
            },
           
        ]
    },{
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Pr Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_1er_Trim_2021_SEDECO.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_2do_Trim_2021_SEDECO.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_3er_Trim_2018_SEDECO.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_4to_Trim_2018_SEDECO.zip"
            }
        ]
    },{
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_1er_Trim_2020_SEDECO.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_2do_Trim_2020_SEDECO.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_3er_Trim_2020_SEDECO.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_4to_Trim_2020_SEDECO.zip"
            }
        ]
    },{
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_1er_Trim_2019_SEDECO.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_2do_Trim_2019_SEDECO.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_3er_Trim_2019_SEDECO.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_4to_Trim_2019_SEDECO.zip"
            }
        ]
    },{
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_1er_Trim_2018_SEDECO.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_2do_Trim_2018_SEDECO.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_3er_Trim_2018_SEDECO.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SIPOT_4to_Trim_2018_SEDECO.zip"
            }
        ]
    },{
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.inai.org.mx/vut-web/?idSujetoObigadoParametro=2131&idEntidadParametro=13&idSectorParametro=21"
            }
        ]
    },{
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "https://sedeco.hidalgo.gob.mx/transparencia/zip/SEDECO%2021%20rubros%202017.zip"
            }
        ]
    }
]